import { useJwmLinkFragment } from './JwmLinkFragment.generated';
import { useShouldHideLinkingDetails } from './useShouldHideLinkingDetails';

/**
 * Will return jwmLink data for the given organization if it has a linked JWM instance.
 */
export const useJwmLinkOrganization = (workspaceId?: string) => {
  const { data } = useJwmLinkFragment({
    from: { id: workspaceId },
    variables: { orgId: workspaceId },
  });

  const shouldHideLinkingDetails = useShouldHideLinkingDetails(workspaceId);

  if (!data?.jwmLink || shouldHideLinkingDetails) {
    return null;
  }

  return data.jwmLink;
};
